import React from "react";
import './BuiltInTests.scss';

import { calculateAverageDuration, calculateAverageEntries, 
    calculateTargetAccuracy, calculateAverageClicks, calculateTargetsPerMinute } from "./resources/TargetTestCalcs";

function DisplayTargetResults(props){
  const completedTargets = props.completedTargets || [];

  return(
    <div>
    {(completedTargets.length > 0) 
      ? 
      <>
      <h2>Activity Complete! Good job!</h2>
      <div className="aa-review-row"> 
        <p><strong>Speed: </strong>{calculateTargetsPerMinute(completedTargets).toFixed(1) + ' targets/min'}</p>
        <p><strong>Accuracy: </strong>{calculateTargetAccuracy(completedTargets).toFixed(0) + '%'}</p>
      </div>
      <table className="aa-test-table">
        <thead>
          <tr>
            <th>Target</th>
            <th>Time Taken (sec)</th>
            <th>Entries</th>
            <th>Clicks</th>
          </tr>
        </thead>
        <tbody>
        {completedTargets.map((t, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td><PrettyPrint numberStr={((t.duration / 1000)).toFixed(1)}/></td>
              <td><PrettyPrint numberStr={t.targetEntries.toFixed(0)}/></td>
              <td><PrettyPrint numberStr={t.clicks.toFixed(0)}/></td>
            </tr>
          ))}
          <tr className="average-row" key={completedTargets.length + 1}>
            <td>Average</td>
            <td><PrettyPrint numberStr={(calculateAverageDuration(completedTargets)/1000).toFixed(1)}/></td>
            <td><PrettyPrint numberStr={calculateAverageEntries(completedTargets).toFixed(1)}/></td>
            <td><PrettyPrint numberStr={calculateAverageClicks(completedTargets).toFixed(1)}/></td>
          </tr>
        </tbody>
      </table>
      </>
      :
      <p>There are no data to display.</p>
    }
    </div>
  );
}

function PrettyPrint(props){
  const numberStr = props.numberStr;
  if (numberStr && ((numberStr==='NaN') || (numberStr==='Infinity'))){
    return("-");
  }
  else return(numberStr);
}

export default DisplayTargetResults;
